import { useEffect } from "react";
import "./despachos.css";
import { useStoreDespachos } from "./useStoreDespachos";
import { MensajeError, useWindowDimensions } from "../../componentes/FuncionesLocales";
import { TabMenu } from "primereact/tabmenu";
import DespachoTab1 from "./DespachosTab1";
import DespachoTab2 from "./DespachoTab2";
import DespachoTab3 from "./DespachoTab3";
import { useStoreLogin } from "../Login/useStoreLogin";
import { useStoreHome } from "../Home/useStoreHome";
import { useNavigate } from "react-router-dom";
import BotonInstructivo from "../../ComponentesGlobales/BotonInstructivo";

const Despachos = () => {
  const Fecha = useStoreDespachos((state) => state.Fecha);
  const Numero = useStoreDespachos((state) => state.Numero);
  const DespachoOk = useStoreDespachos((state) => state.DespachoOk);
  const EliminoOk = useStoreDespachos((state) => state.EliminoOk);
  const TabSeleccionado = useStoreDespachos((state) => state.TabSeleccionado);
  const FechaCaducidad = useStoreHome((state) => state.FechaCaducidad);
  const navigate = useNavigate();

  const { width } = useWindowDimensions();

  useEffect(() => {
    if (!useStoreLogin.getState().validarVariablesGlobales()) {
      useStoreLogin.getState().logout();
    }
    useStoreDespachos.setState({ ListaDetalle: [], ListaGrilla: [] });
    useStoreDespachos.getState().getClientes();
    useStoreDespachos.getState().getFechas();
  }, []);

  useEffect(() => {
    if (FechaCaducidad) {
      if (FechaCaducidad < new Date()) {
        MensajeError(
          "La licencia de uso ha caducado. Contacte a soporte técnico.",
        );
        navigate("/home");
      }
    }
  }, [FechaCaducidad, navigate]);

  useEffect(() => {
    useStoreDespachos.getState().getDespachosPorFechaPantalla();
  }, [Fecha]);

  useEffect(() => {
    if (Number(Numero) > 0) {
      useStoreDespachos.getState().getDatosDespachos();
    } else
      useStoreDespachos.setState({
        Cliente: null,
        DespachoId: 0,
        ListaDetalle: [],
        ListaGrilla: [],
        Seleccionados: [],
      });
  }, [Numero]);

  /* const Cliente = useStoreDespachos((s) => s.Cliente);
  useEffect(() => {
    if (Number(Numero) > 0) {
      useStoreDespachos.getState().getDatosDespachos();
    } else {
      useStoreDespachos.setState({
        Cliente: null,
        DespachoId: 0,
        ListaDetalle: [],
        ListaGrilla: [],
        Seleccionados: []
      });
    }
    }, [Numero, Cliente]);  */

  useEffect(() => {
    if (DespachoOk) {
      useStoreDespachos.setState({ DespachoOk: false });
      useStoreDespachos.getState().limpiar();
    }
  }, [DespachoOk]);

  useEffect(() => {
    if (EliminoOk) {
      useStoreDespachos.setState({ EliminoOk: false });
      useStoreDespachos.getState().limpiar();
    }
  }, [EliminoOk]);

  const items = [
    { label: "Destino", icon: "pi pi-truck" },
    { label: "Producto", icon: "pi pi-box" },
    { label: "Detalles", icon: "pi pi-list" },
  ];

  const items2 = [
    { label: "Destino", icon: "pi pi-truck" },
    { label: "Producto", icon: "pi pi-box" },
  ];

  return (
    <div className="despachos">
      <div
        className="ing-header"
        style={{
          alignItems: "center",
          backgroundColor: "#ffa807ff",
          padding: "12px 16px",
          borderRadius: "8px",
          color: "#fff",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
        }}
      >
        <span className="modulo-icono" aria-hidden="true"><i className="pi pi-truck" /></span>
        <div>
          <h2
            className="ing-titulo"
            style={{
              color: "#f4f4f4ff",
              textShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
            }}
          >
            Despachos
          </h2>
          <p
            className="desp-parrafo"
            style={{
              color: "#f4f4f4ff",
              textShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
            }}
          >
            Realizá la baja del inventario de los productos despachando a
            clientes
          </p>
        </div>

        <BotonInstructivo to="/tutorial/despachos" sobreColor className="despachos-instructivo" />
      </div>

      {width < 768 ? (
        <div className="desp-content-scroll">
          <TabMenu
            model={items}
            activeIndex={Number(TabSeleccionado)}
            onTabChange={(e) =>
              useStoreDespachos.setState({ TabSeleccionado: e.index })
            }
          />
          <div className="desp-layout animado-entrada">
            {TabSeleccionado === 0 && (
              <div className="desp-formulario">
                <div className="desp-bloques-form">
                  <DespachoTab1 />
                </div>
              </div>
            )}
            {TabSeleccionado === 1 && (
              <div className="desp-formulario">
                <div className="desp-bloques-form">
                  <DespachoTab2 />
                </div>
              </div>
            )}
            {TabSeleccionado === 2 && <DespachoTab3 />}
          </div>
        </div>
      ) : width < 1000 ? (
        <div className="desp-content-scroll">
          <TabMenu
            model={items2}
            activeIndex={TabSeleccionado}
            onTabChange={(e) =>
              useStoreDespachos.setState({ TabSeleccionado: e.index })
            }
          />
          <div className="desp-layout animado-entrada">
            <div className="desp-formulario">
              <div className="desp-bloques-form">
                {TabSeleccionado === 0 && <DespachoTab1 />}
                {TabSeleccionado === 1 && <DespachoTab2 />}
              </div>
            </div>
            <DespachoTab3 />
          </div>
        </div>
      ) : (
        <div className="desp-content-scroll">
          <div className="desp-layout animado-entrada">
            <div className="desp-formulario">
              <div className="desp-bloques-form">
                <DespachoTab1 />
                <DespachoTab2 />
              </div>
            </div>
            <div className="desp-registros">
              <DespachoTab3 />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Despachos;
